import React from 'react';
import Slider from 'react-slick';

import GalleryItem from './DesktopGallery/GalleryItem';
import { customizeProducts } from './customizeProducts';

const carouselSettings = {
  slidesToShow: 1,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '0px',
        slidesToShow: 1,
        dots: true,
        dotsClass: 'slick-dots',
      },
    },
    {
      breakpoint: 480,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '0px',
        slidesToShow: 1,
        dots: true,
        dotsClass: 'slick-dots',
        appendDots: (dots) => (
          <div>
            <ul>
              {dots}
            </ul>
          </div>
        ),
      },
    },
  ],
};

const Carousel = () => (
  <Slider {...carouselSettings}>
    {customizeProducts.map((prod, index) => (
      <div key={prod.name} aria-hidden="true" tabIndex={index} style={{ width: '100%' }}>
        <GalleryItem
          image={prod.image}
          name={prod.name}
          description={prod.description}
          customizeCampaign={prod.customizeCampaign}
        />
      </div>
    ))}
  </Slider>
);

export default Carousel;
